export default theme => ({
  warning: {
    display: "flex"
  },
  icon: {
    marginRight: 5,
    color: theme.palette.warning.main,
    display: "inline-block",
  },
  message: {
    color: theme.palette.warning.main,
    display: "inline-block",
  },
});
